module.exports = __webpack_public_path__ + "img/9.58e2949b.webp";